module.exports = __webpack_public_path__ + "assets/img/ic-intro-approve.b263b631.png";